import React, { useState } from 'react';

import { Delete } from '@mui/icons-material';
import { Button, CircularProgress, Dialog, DialogActions, DialogTitle } from '@mui/material';

const DeleteWithConfirmation = ({ onRemove }) => {
  const [open, setOpen] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button variant='contained' color='secondary' disabled={isRemoving} onClick={handleClickOpen}>
        {isRemoving ? <CircularProgress size={24} /> : <Delete />}
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Confirmez la suppression ?</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
          <Button
            onClick={async () => {
              setIsRemoving(true);
              try {
                await onRemove();
              } finally {
                setIsRemoving(false);
                handleClose();
              }
            }}
            color='secondary'
            autoFocus
          >
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteWithConfirmation;
